import React from 'react';

export const UserPortalContext = React.createContext(undefined);
export const DateRangeContext = React.createContext({});
